/*----------测试环境----------*/
/*接口请求路径  */
// export let baseUrl = 'http://localhost:8871/cms';
// /*发布变量*/
// export let productionTip=false;



/*------------正式环境---------*/
export let baseUrl = 'http://gatewaytest.lechun.cc/lechun-cms';
export let balanceUrl = 'http://gatewaytest.lechun.cc/lechun-balance';

export let productionTip=true;


// WEBPACK FOOTER //
// ./src/global/global-bak.js